
<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="contact-dialog">
    <div class="contact__dialog-header">
        <div class="mobile-back-button">
            <button mat-button (click)="close()">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            {{ 'GENERAL_SETTINGS_LABEL' | translate }}
        </div>
        <div class="desktop-close-button">
            <button mat-button (click)="close()">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="contact__dialog-body">
        <div class="content">
             <mat-form-field class="setting-component-form-field">
              <mat-label class="option-label">{{ 'LANGUAGE_LABEL'| translate}}</mat-label>
              <mat-select  [(ngModel)]="selectedLanguage" (selectionChange)="updateOptions()">
                <mat-select-trigger *ngFor="let option of supportedLanguages">
                  <div class="mat-trigger-block" *ngIf="option.value === selectedLanguage">
                    <div class="mat-trigger-text-style">{{ option.display|translate }}</div>
                    <span class="mat-trigger-icon-style">
                      <ng-template [ngTemplateOutlet]="matSelectTriggerIcon">
                      </ng-template>
                    </span>
                  </div>
                </mat-select-trigger>
                <mat-option [attr.id]="option.elementId" *ngFor="let option of supportedLanguages"
                    [value]="option.value">{{ option.display|translate }}
                    <mat-icon *ngIf="option.value == selectedLanguage" matSuffix fontSet="mdi" fontIcon="mdi-check"></mat-icon>
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="showServerSettings">
                    <input matInput class="form-control" placeholder="{{'SERVER_URL' | translate}}"
                    [(ngModel)]="serverURL" #serverurl="ngModel" name="serverurl"
                    autocomplete="nope" (change)="updateOptions()"/>
            </mat-form-field>

            <div class="setting-row" *ngIf="!isCordova && isSupport2FA">
                <vnc-toggle-switch [size]="'s'" label="{{ 'ENABLE_TWO_FACTOR_AUTHENTICATION'| translate}}"
                labelPosition="before" [checked]="use2FA" tooltipLabel="{{ (use2FA ? 'DISABLE' : 'ENABLE') | translate }}"
                (changeEvent)="enableTwofactor($event)"></vnc-toggle-switch>
            </div>

            <div >
                <!-- <mat-checkbox color="primary" [(ngModel)]="use2FA">{{ 'ENABLE_TWO_FACTOR_AUTHENTICATION' | translate }}</mat-checkbox> -->
                <div *ngIf="!isCordova && use2FA && !is2FAEnabled">
                    <div class="start-authenticator-app" (click)="setAuthenticationApp()">
                        {{'START_AUTHENTICATOR_APP' | translate }}
                    </div>
                </div>
            </div>

             <div class="setting-row">
                <vnc-toggle-switch [size]="'s'" label="{{ 'DARK_MODE'| translate}}"
                labelPosition="before" [checked]="darkMode" tooltipLabel="{{ (darkMode ? 'DISABLE' : 'ENABLE') | translate }}"
                (changeEvent)="enableChangeDarkMode($event)"></vnc-toggle-switch>
            </div>
        </div>
    </div>
    <div class="contact__dialog-footer">
        <div class="desktop-footer">
            <button mat-button (click)="close()">
                {{ 'CANCEL' | translate }}
            </button>
            <button class="primary-button" mat-button (click)="saveSettings()">
                {{ 'SAVE' | translate }}
            </button>
        </div>
        <div class="mobile-footer" *ngIf="isUpdated">
            <div class="title">
                {{ 'SAVE' | translate }}
            </div>
            <div class="save_footer_btn">
                <button mat-button (click)="saveSettings()">
                    <mat-icon>check</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>


<ng-template #matSelectTriggerIcon>
<svg width="24px" height="24px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Icon/product/keyboard-arrow-down-new</title>
  <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
  </g>
</svg>
</ng-template>